import { render, staticRenderFns } from "./EventDetailsTabGeneral.vue?vue&type=template&id=ffa8e7ba"
import script from "./EventDetailsTabGeneral.vue?vue&type=script&lang=js"
export * from "./EventDetailsTabGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports